import React from 'react';
import { Tooltip } from 'react-tooltip';

import './style.scss';

const TooltipWrapper = ({ tooltipId, data = [], htmlContent, children }) => {
  const tooltipHtml = data
    ? `<ul class="react-tooltip-list">${data.map(item => `<li class="react-tooltip-list-item">${item}</li>`).join('')}</ul>`
    : htmlContent || '';

  return (
    <>
      <span
        data-tooltip-id={tooltipId}
        data-tooltip-html={tooltipHtml}
        className='cursor-pointer underline'
      >
        {children}
      </span>
      <Tooltip id={tooltipId} />
    </>
  );
};

export default TooltipWrapper;